module.exports = __webpack_public_path__ + "assets/images/01_active_785b86bca75155723f10ef3921a1752f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/01_active.png
// module id = 117
// module chunks = 0